var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canMessage)?_c('button-component',{staticClass:"start-conversation-button",attrs:{"data-test-id":"start-conversation-button"},on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v("Private message")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }